import { createSelector } from 'reselect';
import { search as query, routes, pathname } from './routing';
import { parseSearch } from '../util/url';
import isEmpty from 'lodash/isEmpty';

export const app = ({ app = {} } = {}) => app;

export const appName = createSelector(app, ({ appName }) => appName);

export const navigate = createSelector(app, ({ navigate }) => navigate);

export const appPage = createSelector(app, ({ page = {} }) => page);

export const appStore = createSelector(app, ({ store = {} }) => store);

export const routePage = createSelector(
  appPage,
  pathname,
  (page, path) => page[path] || {}
);

export const routeStore = createSelector(
  appStore,
  pathname,
  (store, path) => store[path] || {}
);

export const searchSchema = createSelector(
  routePage,
  ({ searchSchema }) => searchSchema
);

export const appPageSearch = createSelector(routePage, ({ search }) => search);

export const parsedQuery = createSelector(
  query,
  searchSchema,
  (query, searchSchema) => {
    return query ? parseSearch(query, searchSchema) : null;
  }
);

export const parsedQueryText = createSelector(
  parsedQuery,
  query => query && query.text
);

export const search = createSelector(
  appPageSearch,
  parsedQuery,
  (search = {}, query) => (Object.keys(search).length ? search : query)
);

export const searchWithDefaults = (defaults = {}) => {
  const container = {}; // Infinite update loop if a new object is returned so use a static reference
  return createSelector(
    search,
    () => defaults,
    (search, defaults) => Object.assign(container, defaults, search)
  );
};

// TODO Remove after common search is complete
export const queryWithDefaults = (defaults = {}) => {
  return createSelector(
    parsedQuery,
    () => defaults,
    (query, defaults) => ({ ...defaults, ...query })
  );
};

export const searchText = createSelector(
  search,
  search => search && search.text
);

export const expandSearch = createSelector(
  routePage,
  searchText,
  ({ expandSearch }, text) =>
    expandSearch !== undefined ? expandSearch : !isEmpty(text)
);

export const createPageSelector = key =>
  createSelector(routePage, page => page[key]);

export const createStoreSelector = key =>
  createSelector(routeStore, page => page[key]);

export const routeProps = createSelector(routes, (routes = []) =>
  routes.reduce(
    (
      o,
      {
        childRoutes,
        children,
        component,
        components,
        getComponent,
        getComponents,
        indexRoute,
        onChange,
        onEnter,
        onLeave,
        path,
        ...props
      }
    ) => ({
      ...o,
      ...props
    }),
    {}
  )
);

export const page = createSelector(
  routePage,
  appName,
  navigate,
  search,
  expandSearch,
  routeProps,
  (page, appName, navigate, search, expandSearch, props) => ({
    appName,
    navigate,
    ...{ ...props, ...page },
    search,
    expandSearch
  })
);



// WEBPACK FOOTER //
// ./js/selectors/app.js